/* eslint-disable */
import React, {useState} from 'react';
//css
import 'contents/assets/scss/page/teacher.scss';
//component
import LineChart from '../../../component/Inc/LineChart';
//image

function TeacherYearStatistics() {
  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  //연간 평균 타임수
  const yearlabels = ['2019', '2020', '2021', '2022', '2023'];
  const dataYear = {
    lineChartlabels: yearlabels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [10000, 20000, 40000, 20000, 50000, 60000],
        backgroundColor: '#3780ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  const monthlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  //월간 중단 등급
  const dataMonthCancel = {
    lineChartlabels: monthlabels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 60000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //월간 손실
  const dataMonthLoss = {
    lineChartlabels: monthlabels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 60000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //월간 평균 타임수
  const dataMonthTime = {
    lineChartlabels: monthlabels,
    datasets: [
      {
        label: 'Dataset 2',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 60000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //월간 중단 건 수, 중단 타임 수
  const dataMonthCancelTime = {
    lineChartlabels: monthlabels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [10000, 20000, 40000, 20000, 10000, 20000, 10000, 10000, 20000, 10000, 20000, 10000, 20000, 0],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: 'Dataset 2',
        data: [30000, 20000, 20000, 0, 50000, 20000, 20000, 10000, 20000, 40000, 20000, 40000, 10000, 40000],
        backgroundColor: '#3780ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  return (
    <main className="com_container p_teacher_year_statistics">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_14 active">
            연간실적 통계
            <span className="bar"></span>
            <span className="point_txt">홍교사103ㆍ수학</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full ">
            <article className="">
              <div className="detail_tit dot">연간 평균 수업 수</div>
              <LineChart data={dataYear} width={lineChartWidth} height={lineChartHeight} />
            </article>
            <hr className="com_divider" />
            <div className="com_sec_top_card_graph">
              <article className="wrap">
                <div className="detail_tit dot">월간 중단 등급</div>
                <LineChart data={dataMonthCancel} width={lineChartWidth} height={lineChartHeight} />
              </article>
              <article className="wrap">
                <div className="detail_tit dot">월간 손실률</div>
                <LineChart data={dataMonthLoss} width={lineChartWidth} height={lineChartHeight} />
              </article>
              <article className="wrap">
                <div className="detail_tit dot">월간 평균 진행 타임 수</div>
                <LineChart data={dataMonthTime} width={lineChartWidth} height={lineChartHeight} />
              </article>
              <article className="wrap">
                <div className="detail_tit dot">월간 중단 건 수, 중단 타임 수</div>
                <LineChart data={dataMonthCancelTime} width={lineChartWidth} height={lineChartHeight} />
              </article>
            </div>
          </div>
          <div className="box full">
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="84" />
                <col width="130" />
                <col width="130" />
                <col width="130" />
              </colgroup>
              <thead>
                <tr>
                  <th>비고</th>
                  <th>1월</th>
                  <th>2월</th>
                  <th>3월</th>
                  <th>4월</th>
                  <th>5월</th>
                  <th>6월</th>
                  <th>7월</th>
                  <th>8월</th>
                  <th>9월</th>
                  <th>10월</th>
                  <th>11월</th>
                  <th>12월</th>
                  <th>2022</th>
                  <th>2023</th>
                  <th>증감율</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="bg_col">중단 등급</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt">10</td>
                  <td className="com_blue_txt bg_col">-</td>
                  <td className="com_blue_txt bg_col">10</td>
                  <td className="bg_col"></td>
                </tr>
                <tr>
                  <td className="bg_col">손실률(%)</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt">55</td>
                  <td className="com_blue_txt bg_col">-</td>
                  <td className="com_blue_txt bg_col">55</td>
                  <td className="bg_col"></td>
                </tr>
                <tr>
                  <td className="bg_col">전임 등급</td>
                  <td className="com_blue_txt">
                    9<br />
                    전임교사
                  </td>
                  <td className="com_blue_txt">
                    9<br />
                    파트교사
                  </td>
                  <td className="com_blue_txt">
                    9<br />
                    파트교사
                  </td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="bg_col com_blue_txt">
                    9<br />
                    전임교사
                  </td>
                  <td className="bg_col com_blue_txt">
                    9<br />
                    전임교사
                  </td>
                  <td className="bg_col"></td>
                </tr>
                <tr>
                  <td className="bg_col">타임수</td>
                  <td>455</td>
									<td>455</td>
                  <td>455</td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="bg_col com_blue_txt">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">
                    <span className="arrow_blue">126</span>
                  </td>
                </tr>
                <tr>
                  <td className="bg_col">인계</td>
                  <td>455</td>
									<td>455</td>
                  <td>455</td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="bg_col com_blue_txt">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">
                    <span className="arrow_blue down">126</span>
                  </td>
                </tr>
                <tr>
                  <td className="bg_col">중단</td>
                  <td>455</td>
									<td>455</td>
                  <td>455</td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="bg_col com_blue_txt">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">
                    <span className="arrow_blue">126</span>
                  </td>
                </tr>
                <tr>
                  <td className="bg_col">취소</td>
                  <td>455</td>
									<td>455</td>
                  <td>455</td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="bg_col com_blue_txt">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">
                    <span className="arrow_blue">126</span>
                  </td>
                </tr>
                <tr>
                  <td className="bg_col">종료</td>
                  <td>455</td>
                  <td>455</td>
                  <td>455</td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="com_blue_txt"></td>
                  <td className="bg_col com_blue_txt">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">
                    <span className="arrow_blue">126</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  );
}

export default TeacherYearStatistics;
